// Department status options
export const DEPARTMENT_STATUS = {
  ACTIVE: 'active',
  INACTIVE: 'inactive'
};

export const DEPARTMENT_STATUS_OPTIONS = [
  { value: DEPARTMENT_STATUS.ACTIVE, label: 'Active' },
  { value: DEPARTMENT_STATUS.INACTIVE, label: 'Inactive' }
];

// Default department data structure
export const DEFAULT_DEPARTMENT = {
  sector: '',
  departmentName: '',
  departmentCode: '',
  priority: 1,
  isActive: true,
  createdAt: null,
  updatedAt: null
};

// Validation limits
export const DEPARTMENT_VALIDATION = {
  NAME_MIN_LENGTH: 2,
  NAME_MAX_LENGTH: 100,
  PRIORITY_MIN: 1,
  PRIORITY_MAX: 999
};

// Helper function to generate department code from name
export const generateDepartmentCode = (departmentName) => {
  if (!departmentName) return '';
  
  return 'dept-' + departmentName
    .toLowerCase()
    .trim()
    .replace(/[^\w\s-]/g, '')  // Remove special characters
    .replace(/[\s_]+/g, '-')    // Replace spaces/underscores with hyphens
    .replace(/^-+|-+$/g, '');   // Remove leading/trailing hyphens
};

// Helper function to validate department code uniqueness
export const isDepartmentCodeUnique = (code, allDepartments, currentDeptId = null) => {
  return !allDepartments.some(dept => 
    dept.departmentCode === code && dept.id !== currentDeptId
  );
};

// Helper function to get next priority number for a sector
export const getNextPriority = (sector, allDepartments) => {
  const sectorDepts = allDepartments.filter(d => d.sector === sector);
  if (sectorDepts.length === 0) return 1;
  
  const maxPriority = Math.max(...sectorDepts.map(d => d.priority || 0));
  return maxPriority + 1;
};

// Sort departments by priority
export const sortDepartmentsByPriority = (departments) => {
  return [...departments].sort((a, b) => {
    // First by sector
    if (a.sector !== b.sector) {
      return a.sector.localeCompare(b.sector);
    }
    // Then by priority
    return (a.priority || 999) - (b.priority || 999);
  });
};

// Group departments by sector
export const groupDepartmentsBySector = (departments) => {
  const grouped = {};
  
  departments.forEach(dept => {
    if (!grouped[dept.sector]) {
      grouped[dept.sector] = [];
    }
    grouped[dept.sector].push(dept);
  });
  
  // Sort within each sector by priority
  Object.keys(grouped).forEach(sector => {
    grouped[sector].sort((a, b) => (a.priority || 999) - (b.priority || 999));
  });
  
  return grouped;
};